<template>
  <TextInput
    v-validate.disable="'url'"
    :value="streamUrl"
    name="stream"
    :error="errors.first('stream')"
    :class="{ 'is-invalid': errors.first('stream') }"
    :disabled="isTournamentFieldDisabled('stream_url')"
    type="text"
    :label="$$t('Stream:', 'stream-url')"
    :placeholder="
      $$t('Provide an URL from streaming platform', 'stream-url-placeholder')
    "
    :data-vv-as="$$t('Stream', 'stream-url')"
    @change="streamUrl = $event"
  />
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import TextInput from '@/components/atoms/form/HeraFormTextInput';
import { translate } from '@/mixins/translate';
export default {
  name: 'TournamentStreamUrlSetting',
  inject: ['$validator'],
  components: {
    TextInput,
  },
  mixins: [translate('_web_tournament_additional_settings')],
  computed: {
    ...mapGetters(['isTournamentFieldDisabled', 'currentTournament']),
    streamUrl: {
      get() {
        return this.$lodash.get(this.currentTournament, 'info.stream_url', '');
      },
      set(newVal) {
        this.updateCurrentTournament({
          stream_url: newVal,
          component: 'info',
        });
      },
    },
  },
  methods: {
    ...mapMutations(['updateCurrentTournament']),
  },
};
</script>
